export type Exact = 'input' | 'output';
